import { COUNTRIES } from '@mirai/locale';

import { themeDirection } from './themeDirection';

const DEFAULT_APP_LOCALE = 'en-GB';
const DELIMITER = '-';

export const getLocale = (instance = {}, { lang: urlLanguage } = {}) => {
  const [documentLanguage] = document?.documentElement?.getAttribute('lang')?.toLowerCase().split(DELIMITER) || [];
  const [navigatorLanguage, navigatorCountry] =
    (typeof window.navigator.language === 'string' && window.navigator.language?.split(DELIMITER)) || [];
  const [instanceLanguage, instanceCountry] = !urlLanguage ? instance.locale?.split(DELIMITER) || [] : [];

  let baseLanguage = urlLanguage || documentLanguage || instanceLanguage || navigatorLanguage;
  if (baseLanguage === 'no') baseLanguage = 'nb';

  const baseCountry =
    instanceCountry || (baseLanguage === navigatorLanguage ? navigatorCountry : undefined) || COUNTRIES[baseLanguage];

  const [language, country] = COUNTRIES[baseLanguage]
    ? [baseLanguage, baseCountry]
    : DEFAULT_APP_LOCALE.split(DELIMITER);
  themeDirection(language);

  return {
    // ! TODO: country should be the ip.country
    country,
    language,
    locale: [language, country].join('-'),
  };
};
